<template>
	<div>
		<div class="raised-box p-box">
			<SimpleForm
				:onSubmit="onSubmit"
				:fields="[
					{
						label : 'Template name',
						name : 'name',
						autocomplete : 'template-name',
						autofocus : true,
						required : true,
					},
					{
						label : 'Organisation',
						name : 'org_id',
						type : 'org',
						required : true,
					},
					{
						label : 'Template',
						name : 'templateData',
						type : 'template',
						autofocus : true,
						required : true,
					},
				]"
				:model="template"
				:submitBlock="submitBlock"
				submitText="Save Template"
			/>
		</div>

		<div class="raised-box p-box s-above" style="display:flex;align-items:center;justify-content:center;border-top:3px solid red;">
			<i class="far fa-trash-alt c-warning" style="margin-right:10px;"></i> Delete this template: <button :class="{'btn-warning':1,'_btn_submitting':deleting}" @click="deleteTemplate" style="margin:10px;">Delete template</button>
		</div>
	</div>
</template>
<script>

	export default {

		props : ['template'],
		
		data(){
			return {
				deleting : false,
			}
		},

		methods:{

			onSubmit(payload){
				var self = this;
				payload.template = payload.templateData.body;
				payload.variables = payload.templateData.variables;

				return api.update('template',self.template.id,payload).then(function(template){
					self.$emit('update',template);
					self.$router.push({name:'template'})
				});
			},

			submitBlock(payload){
				var body = (payload.templateData||{}).body||'';
				return body.includes('{{VARIABLE MISSING}}') ? 'Missing variable in template body' : false;
			},

			deleteTemplate(){
				var self = this;

				if(!confirm('Are you sure you want to permanently delete this template?')) return false;

				self.deleting = true;

				return api.delete('template',self.template.id).then(function(template){
					self.$router.push({name:'templates'});
				}).catch(function(e){
					alert(e.message || 'Failed to delete template. Try again.');
				}).then(function(){
					self.deleting = false;
				});
			},

		},
	}

</script>